// Global storage for custom colours
window.bsCustomColours = {
  roof: 'Off White',
  wall: 'Off White',
  door: 'Off White',
  active: false
};

// Colour mapping for swatch backgrounds
const colourSwatches = {
  'Off White': '#dfdccd',
  'Smooth Cream': '#ecd7b0',
  'Gull Grey': '#b1b7b2',
  'Mist Green': '#73826a',
  'Slate Grey': '#414441',
  'Monolith': '#2c2c30',
  'Zinc': '#dddddb'
};

class BsPdpCustomColoursModal extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      modalContent: ".bs-custom-colours-modal",
      openBtn: ".bs-custom-colours-trigger",
      applyBtn: ".bs-custom-colours-popup__btn--apply",
      cancelBtn: ".bs-custom-colours-popup__btn--cancel"
    };
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors, this);
    const { modalContent } = this.domNodes;
    if (modalContent && modalContent.innerHTML) {
      this.modalContent = modalContent.innerHTML;
      this.init();
    }
  }

  init() {
    this.modal = new MinimogTheme.Modal();

    // Open modal button
    addEventDelegate({
      selector: this.selectors.openBtn,
      handler: (e) => {
        e.preventDefault();
        if (this.modalContent) {
          const contentElement = document.createElement("DIV");
          contentElement.classList.add("m-sharing__content");
          contentElement.innerHTML = this.modalContent;

          // Apply colour swatches
          const swatches = contentElement.querySelectorAll('.bs-custom-colour-option__swatch');
          swatches.forEach(swatch => {
            const colourName = swatch.dataset.color;
            if (colourSwatches[colourName]) {
              swatch.style.backgroundColor = colourSwatches[colourName];
            }
          });

          // Set current selections
          const roofRadio = contentElement.querySelector(`input[name="roof_colour"][value="${window.bsCustomColours.roof}"]`);
          const wallRadio = contentElement.querySelector(`input[name="wall_colour"][value="${window.bsCustomColours.wall}"]`);
          const doorRadio = contentElement.querySelector(`input[name="door_colour"][value="${window.bsCustomColours.door}"]`);
          if (roofRadio) roofRadio.checked = true;
          if (wallRadio) wallRadio.checked = true;
          if (doorRadio) doorRadio.checked = true;

          // Update title displays
          contentElement.querySelector('#selectedRoofDisplay').textContent = window.bsCustomColours.roof;
          contentElement.querySelector('#selectedWallDisplay').textContent = window.bsCustomColours.wall;
          contentElement.querySelector('#selectedDoorDisplay').textContent = window.bsCustomColours.door;

          // Update title displays when radio buttons change
          const roofRadios = contentElement.querySelectorAll('input[name="roof_colour"]');
          const wallRadios = contentElement.querySelectorAll('input[name="wall_colour"]');
          const doorRadios = contentElement.querySelectorAll('input[name="door_colour"]');

          roofRadios.forEach(radio => {
            radio.addEventListener('change', function() {
              const display = contentElement.querySelector('#selectedRoofDisplay');
              if (display) {
                display.textContent = this.value;
              }
            });
          });

          wallRadios.forEach(radio => {
            radio.addEventListener('change', function() {
              const display = contentElement.querySelector('#selectedWallDisplay');
              if (display) {
                display.textContent = this.value;
              }
            });
          });

          doorRadios.forEach(radio => {
            radio.addEventListener('change', function() {
              const display = contentElement.querySelector('#selectedDoorDisplay');
              if (display) {
                display.textContent = this.value;
              }
            });
          });

          // Apply button handler
          const applyBtn = contentElement.querySelector(this.selectors.applyBtn);
          if (applyBtn) {
            applyBtn.addEventListener('click', () => {
              this.applyCustomColours(contentElement);
            });
          }

          // Cancel button handler
          const cancelBtn = contentElement.querySelector(this.selectors.cancelBtn);
          if (cancelBtn) {
            cancelBtn.addEventListener('click', () => {
              this.modal.close();
            });
          }

          this.modal.appendChild(contentElement);
          this.modal.setSizes("bs-custom-colours-modal");
          this.modal.open();
        }
      }
    });
  }

  applyCustomColours(contentElement) {
    // Get selected colours
    const roofColour = contentElement.querySelector('input[name="roof_colour"]:checked');
    const wallColour = contentElement.querySelector('input[name="wall_colour"]:checked');
    const doorColour = contentElement.querySelector('input[name="door_colour"]:checked');

    if (roofColour && wallColour && doorColour) {
      window.bsCustomColours.roof = roofColour.value;
      window.bsCustomColours.wall = wallColour.value;
      window.bsCustomColours.door = doorColour.value;

      // Update summary display
      const summary = document.getElementById('customColoursSummary');
      const roofDisplay = document.getElementById('selectedRoofColour');
      const wallDisplay = document.getElementById('selectedWallColour');
      const doorDisplay = document.getElementById('selectedDoorColour');

      if (summary && roofDisplay && wallDisplay && doorDisplay) {
        roofDisplay.textContent = window.bsCustomColours.roof;
        wallDisplay.textContent = window.bsCustomColours.wall;
        doorDisplay.textContent = window.bsCustomColours.door;
        summary.classList.add('active');
        window.bsCustomColours.active = true;

        // Deselect standard colour swatches
        this.deselectStandardColours();
      }

      // Close modal
      this.modal.close();

      // Trigger custom event for other components to listen to
      const event = new CustomEvent('customColoursUpdated', {
        detail: {
          roof: window.bsCustomColours.roof,
          wall: window.bsCustomColours.wall,
          door: window.bsCustomColours.door,
          active: true
        }
      });
      document.dispatchEvent(event);
    }
  }

  deselectStandardColours() {
    // Deselect all standard colour swatches visually
    const colourNodes = document.querySelectorAll('variant-color .m-product-option--node');
    colourNodes.forEach(node => {
      node.classList.remove('selected');
      const input = node.querySelector('input[type="radio"]');
      if (input) input.checked = false;
    });
  }

  static resetCustomColours() {
    window.bsCustomColours.active = false;

    const summary = document.getElementById('customColoursSummary');
    if (summary) {
      summary.classList.remove('active');
    }

    // Trigger reset event
    const event = new CustomEvent('customColoursReset');
    document.dispatchEvent(event);
  }
}

customElements.define("bs-pdp-custom-colours-modal", BsPdpCustomColoursModal);

// Reset button handler
document.addEventListener('click', (e) => {
  if (e.target.matches('#resetCustomColours') || e.target.closest('#resetCustomColours')) {
    BsPdpCustomColoursModal.resetCustomColours();
  }
});

